import { render, staticRenderFns } from "./CbsObjectImport.vue?vue&type=template&id=71923772&scoped=true"
import script from "./CbsObjectImport.vue?vue&type=script&lang=js"
export * from "./CbsObjectImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71923772",
  null
  
)

export default component.exports